interface ValidationRules {
  required?: RequiredType;
  minValue?: number;
}

interface Decoration {
  placeholder?: string;
}

export enum EditableTypes{
  EDITABLE_FOR_ALL='EDITABLE_FOR_ALL',
  EDITABLE_FOR_CONSUMER='EDITABLE_FOR_CONSUMER',
  EDITABLE_FOR_TENANT='EDITABLE_FOR_TENANT',
  EDITABLE_FOR_PARTNERS='EDITABLE_FOR_PARTNERS',
}

export interface FieldConfig {
  type: "string" | "radio" | "single-select" | "boolean" | "multi-select";
  title: string;
  options?: string[];
  initialValue?: string | number | boolean;
  validation?: ValidationRules;
  decoration?: Decoration;
  colSpan?: number;
  infoRender?: React.ElementType;
  editable?: EditableTypes[];
}

export interface AdditionalFields {
  [key: string]: FieldConfig;
}

export enum RequiredType {
  REQUIRED_FOR_ALL = 'REQUIRED_FOR_ALL',
  REQUIRED_FOR_CONSUMER = 'REQUIRED_FOR_CONSUMER',
}

const AdditionalBaseConfig = {
  HOLDINGS: {
    NEW_REGISTRATION_FLOW: {
      ADDITIONAL_FIELDS: {
      } as AdditionalFields
    },
  },
};

export default AdditionalBaseConfig;